import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import ListFormTemplate from "../PageTemplate/ListFormTemplate";
import axios from "axios";
import { config, fuelTypes, transmission } from "../../utils/config";
import {
  fetchDataAndMapToField,
  waitForCookie,
} from "../../utils/helperFuctions";
import { countries } from "../../utils/config";
import { getCookie } from "../../utils/cookieHandler";
import useCustomersLogic from "./useCustomersLogic";

const columns = [
  { field: "id", label: "ID", decimalCount: 0, allowSorting: true },
  {
    field: "concat",
    label: "Name",
    allowSorting: true,
    concatBy: " ",
    concat: [{ field: "first_name" }, { field: "last_name" }],
  },
  { field: "email", label: "Email", allowSorting: true },
  {
    field: "id_number",
    label: "Identity",
    allowSorting: true,
  },
  {
    field: "id_number_expiry",
    label: "Identity expiry",
    allowSorting: true,
    showInFilter: true,
    isDate: true,
  },
  {
    field: "driver_license_number",
    label: "License",
    allowSorting: true,
  },
  {
    field: "branches",
    label: "Branch",
    relationWith: "branch.Name",
    relationSubvalue: "branch.Name",
    isRelation: true,
    allowSorting: true,
    showInFilter: true,
    hide: true,
  },
  {
    field: "total_balances",
    subvalue: "reservations_total_balance",
    label: "Balance (USD)",
    // if it's value is an array
    isArray: true,
    // which item in the array to display
    where: {
      branch: {
        code: "LB",
      },
    },
    decimalCount: 2,
    allowSorting: true,
    sortingRelationSubValue: "reservations_total_balance",
    sortingRelationWhereField: "branch.code",
    sortingRelationWhereValue: "LB",
  },
  {
    field: "total_balances",
    subvalue: "reservations_total_balance",
    label: "Balance (AED)",
    // if it's value is an array
    isArray: true,
    // which item in the array to display
    where: {
      branch: {
        code: "AE",
      },
    },
    decimalCount: 2,
    allowSorting: true,
    sortingRelationSubValue: "reservations_total_balance",
    sortingRelationWhereField: "branch.code",
    sortingRelationWhereValue: "AE",
  },
  {
    field: "total_balances",
    subvalue: "deposits_total_balance",
    label: "Deposit balance (USD)",
    // if it's value is an array
    isArray: true,
    // which item in the array to display
    where: {
      branch: {
        code: "LB",
      },
    },
    decimalCount: 2,
    allowSorting: true,
    sortingRelationSubValue: "deposits_total_balance",
    sortingRelationWhereField: "branch.code",
    sortingRelationWhereValue: "LB",
  },
  {
    field: "total_balances",
    subvalue: "deposits_total_balance",
    label: "Deposit balance (AED)",
    // if it's value is an array
    isArray: true,
    // which item in the array to display
    where: {
      branch: {
        code: "AE",
      },
    },
    decimalCount: 2,
    allowSorting: true,
    sortingRelationSubValue: "deposits_total_balance",
    sortingRelationWhereField: "branch.code",
    sortingRelationWhereValue: "AE",
  },
  {
    field: "has_pending_billing_events",
    label: "Bill",
    allowSorting: true,
    type: "status",
    values: {
      "True": "text-orange-700 ring-orange-600/20 bg-orange-50",
      "False": "text-green-700 ring-green-600/20 bg-green-50",
    },
    displayValues: {
      "True": "Pending",
      "False": "Billed",
      "": "N/A",
    },
    showInFilter: true,
  },
  {
    field: "driver_license_expiry",
    label: "License expiry",
    allowSorting: true,
    showInFilter: true,
    isDate: true,
  },
];

const CustomersPage = () => {
  const { apiRoute, addRoles, editRoles, deleteRoles, initFields, tabsData } =
    useCustomersLogic();
  const [fields, setfields] = useState(initFields);

  const loadOptions = async (branchId) => {
    try {
      const temp = [...initFields];

      //API endpoint to fetch the data
      // Call the function for each API endpoint
      //await fetchDataAndMapToField(config, 'customertypes', 'type', temp);
      await fetchDataAndMapToField(config, "companies", "company", temp);

      setfields(temp);
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  };

  return (
    <div>
      <Helmet>
        <title>Admin | Glide</title>
        <meta name="description" content="Welcome to Customers" />
        {/* Other meta tags */}
      </Helmet>
      <ListFormTemplate
        apiRoute={apiRoute}
        columns={columns}
        fields={fields}
        bringFormData={loadOptions}
        tabsData={tabsData}
        createRoles={addRoles}
        deleteRoles={deleteRoles}
        editRoles={editRoles}
        tableNameInDb={"contact"}
      />
    </div>
  );
};

export default CustomersPage;
